export const tableColumnsManagement = [
/*  {
    Header: 'Id',
    accessor: 'id',
  },*/
  {
    Header: 'NOTIFY',
    accessor: 'button',
  },
  {
    Header: 'Title',
    accessor: 'title',
  },
  {
    Header: 'Image',
    accessor: 'imageUrl',
  },
  {
    Header: 'Description',
    accessor: 'description',
  },
  {
    Header: 'Button Text',
    accessor: 'buttonText',
  },
  {
    Header: 'Button URL',
    accessor: 'buttonUrl',
  },
  {
    Header: 'Expiry Date',
    accessor: 'expiryDate',
  },
/*  {
    Header: 'Active',
    accessor: 'active',
  },*/
  {
    Header: 'Created Time',
    accessor: 'createdTime',
  },
  {
    Header: 'Last Updated',
    accessor: 'lastModified',
  }
];
